import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { EnumTotemType } from '@/pages/StoreManagement/states';
import { RECAPTCHA_HEADER } from '@/hooks/useRecaptcha';
import { useRequiredRecaptchaToken } from '@/contexts/Recaptcha';
import api from '../../../services/api';
import queryClient from '../../queryClient';
import { QUERY_EXCEL_EXPORT } from '../../salles/GetExcel/useExcelExport';
import { InventoryType } from '../types';

interface PropsExcel {
    group?: string[] | null;
    name?: string;
    shopmanagerId?: number;
    shopmanagerEmail?: string;
    city?: string;
    state?: string;
    stores?: Array<number>;
    referenceDate?: string;
    totem?: boolean;
    active?: boolean;
    initialDate?: string;
    finalDate?: string;
    storeId?: number;
    totemEnum?: EnumTotemType;
    productIds?: Array<number>;
    timezone?: string;
    includeDeleted?: boolean;
    open?: boolean;
    reportType?: string;
    productName?: string;
    categoryId?: number;
    isTotemAuthenticated?: boolean | null;
    inventory?: InventoryType[];
}

const createExcellExportFetch = async (data: PropsExcel, reCaptcha: string) => {
    const response = await api.post(
        `/reports/v2/export-xlsx`,
        { ...data },
        { headers: { [RECAPTCHA_HEADER]: reCaptcha } },
    );
    return response.data;
};

export const useReport = () => {
    const getRecaptchaToken = useRequiredRecaptchaToken();

    return useMutation({
        mutationFn: async (data: PropsExcel) =>
            createExcellExportFetch(data, await getRecaptchaToken()),
        onError: (error: AxiosError) => error,
        onSuccess: () => {
            queryClient.invalidateQueries([QUERY_EXCEL_EXPORT]);
        },
    });
};
